<template>
    <div style="width: 23.49%;
          height: calc(100vh - 126px);
          position: absolute;
          right: 10px;
          top: 90px;">
        <div style="width: 100%; height: calc(50% - 0px)" class="backGround innerbox">
            <p class="card-title"><img src="../assets/titleL.png" alt="">&nbsp;{{ oneTitle }}&nbsp;<img
                    src="../assets/titleR.png" alt=""></p>
            <div class="recycle-record">
                <div id="chart" style="width: 100%; height: 100%"></div>
            </div>
        </div>

        <div style="width: 100%; height: calc(50% - 0px)" class="backGround innerbox">
            <p class="card-title"><img src="../assets/titleL.png" alt="">&nbsp;{{ twoTitle }}&nbsp;<img
                    src="../assets/titleR.png" alt=""></p>
            <div class="recycle-record">

                <div class="recycle-record-content" style="height: calc(100% - 50px);">
                    <div class="recycle-record-content-line">
                        <el-cascader
                                style="float: left;margin-left: 5px;margin-top: 10px"
                                v-model="value1"
                                :options="options"
                                :props="{ expandTrigger: 'hover' }"
                                @change="handleChange"
                        ></el-cascader>

                    </div>

                    <div style="float: left;margin-top: 20px">
                        <div v-if="value1[1]=='01'">
                            <span style="margin-right: 10px"> 下泄流量:</span>
                            <el-input style="width: 200px" v-model="input1"></el-input>
                        </div>

                        <div v-if="value1[1]=='02'">
                            <el-form :inline="true" style="float: left;margin-top: 20px">

                                <div v-for="(item, index) in flowList" :key="index">
                                    <el-form-item
                                            label-width="80px"
                                            label="入库流量"
                                            :prop="'flowList.' + index + '.in'"

                                    >
                                        <el-input size="mini" style="width: 80px" v-model="item.in"></el-input>
                                    </el-form-item>
                                    <el-form-item
                                            label-width="100px"
                                            label="下泄流量"

                                            :prop="'flowList.' + index + '.out'">
                                        <el-input size="mini" style="width: 80px;" v-model="item.out"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <i class="el-icon-delete" @click="deleteItem(item, index)"></i>
                                    </el-form-item>
                                </div>
                                <div style="display: flex;align-items: center;justify-content: center;">
                                    <el-button style="background-color: #14d7d7;" type="primary" size="mini"
                                               @click="addItem">增加方案
                                    </el-button>
                                </div>



                            </el-form>
                        </div>

                        <div v-if="value1[0]=='2'">
                            <span style="margin-right: 10px"> 库水位设置:</span>
                            <el-input style="width: 200px" v-model="input2"></el-input>
                        </div>
                    </div>
<!--                    <el-button v-if="value1!=''" style="background-color: #14d7d7;position:absolute; bottom:20px; right:150px;" type="primary" size="mini"-->
<!--                               @click="riverLevel">水库调节-->
<!--                    </el-button>-->
                    <el-button v-if="value1!=''" style="background-color: #14d7d7;position:absolute; bottom:20px; right:20px;" type="primary" size="mini"
                               :loading="isComputing"
                               @click="adjust">开始预演
                    </el-button>
                </div>

            </div>

        </div>
        <div v-if="dispatchResult" class="dispatch-result backGround innerbox">
            <p class="card-title"><img src="../assets/titleL.png" alt="">&nbsp;调度方案比选&nbsp;<img
                    src="../assets/titleR.png" alt=""></p>
            <div class="dispatch-summary">{{ dispatchResult.summary }}</div>
            <div class="scheme-list">
                <div v-for="scheme in dispatchResult.schemes" :key="scheme.scheme_id"
                     class="scheme-card"
                     :class="{ recommended: scheme.scheme_id === dispatchResult.recommended_scheme_id }">
                    <div class="scheme-name">{{ scheme.scheme_name }}</div>
                    <div class="scheme-grid">
                        <span>最高水位：{{ scheme.metrics.max_level }} m</span>
                        <span>削峰率：{{ scheme.metrics.peak_reduction_rate }}%</span>
                        <span>峰值下泄：{{ scheme.metrics.peak_release }} m³/s</span>
                        <span>风险：{{ scheme.metrics.risk_level }}</span>
                    </div>
                    <div class="scheme-tip">{{ scheme.recommendation }}</div>
                </div>
            </div>
            <div class="workflow-panel">
                <div class="workflow-title">调度执行闭环</div>
                <div class="workflow-status">
                    <span>方案：{{ workflowScheme ? workflowScheme.scheme_id : '未创建' }}</span>
                    <span>状态：{{ workflowScheme ? workflowScheme.status : '-' }}</span>
                    <span>执行：{{ workflowScheme ? workflowScheme.execution_status : '-' }}</span>
                    <span>指令：{{ workflowCommand ? workflowCommand.command_id : '-' }}</span>
                </div>
                <div class="workflow-actions">
                    <el-button size="mini" type="primary" :loading="workflowLoading" @click="createWorkflowScheme">创建方案</el-button>
                    <el-button size="mini" :disabled="!workflowScheme || workflowScheme.status !== 'draft'" :loading="workflowLoading" @click="submitWorkflowScheme">提交</el-button>
                    <el-button size="mini" :disabled="!workflowScheme || workflowScheme.status !== 'submitted'" :loading="workflowLoading" @click="approveWorkflowScheme">审批确认</el-button>
                    <el-button size="mini" :disabled="!workflowScheme || workflowScheme.status !== 'approved'" :loading="workflowLoading" @click="issueWorkflowCommand">下发指令</el-button>
                    <el-button size="mini" :disabled="!workflowCommand || workflowCommand.status !== 'issued'" :loading="workflowLoading" @click="completeWorkflowReceipt">回执完成</el-button>
                    <el-button size="mini" type="warning" :disabled="!workflowCommand || workflowCommand.status !== 'issued'" :loading="workflowLoading" @click="failWorkflowReceipt">回执失败</el-button>
                    <el-button size="mini" type="warning" :disabled="!workflowCommand || workflowCommand.status !== 'failed'" :loading="workflowLoading" @click="retryWorkflowCommand">失败重试</el-button>
                    <el-button size="mini" type="danger" :disabled="!workflowScheme || workflowScheme.execution_status === 'completed' || workflowScheme.status === 'cancelled'" :loading="workflowLoading" @click="cancelWorkflowScheme">取消方案</el-button>
                    <el-button size="mini" :loading="workflowLoading" @click="loadWorkflowAudit">审计</el-button>
                </div>
                <div v-if="workflowMessage" class="workflow-message">{{ workflowMessage }}</div>
                <div v-if="workflowAudit.length" class="workflow-audit">
                    <div v-for="item in workflowAudit.slice(-5)" :key="item.audit_id" class="audit-line">
                        {{ item.created_at }} / {{ item.action }} / {{ item.actor }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Cesium from "cesium";
import {
    approveDispatchScheme,
    cancelDispatchScheme,
    compareDispatch,
    createDispatchScheme,
    fetchDispatchAudit,
    issueDispatchCommand,
    recordDispatchReceipt,
    retryDispatchCommand,
    runFloodScenario,
    submitDispatchScheme
} from '@/services/hydroService.js'

export default {
    name: "custom",
    data() {
        return {
            oneTitle: "水位库容",
            twoTitle: "调度方式",
            dialogVisible: false,
            showFlag: true,
            flowList: [{
                in: '',
                out: ''
            }],
            value: '',
            value1: '',
            input1: '',
            input2:'',
            isComputing: false,
            dispatchResult: null,
            floodScenario: null,
            lastDispatchPayload: null,
            workflowLoading: false,
            workflowScheme: null,
            workflowCommand: null,
            workflowAudit: [],
            workflowMessage: '',
            options: [{
                value: '0',
                label: '固定下泄调度',
                children: [{
                    value: '01',
                    label: '一级固定泄流',
                },
                    {
                        value: '02',
                        label: '多级固定泄流',
                    }]
            }, {
                value: '1',
                label: '补偿调度'
            },
            //   {
            //     value: '2',
            //     label: '防洪预报调度'
            // }, {
            //     value: '3',
            //     label: '防洪与兴利联合调度'
            // }
            ],

        }
    },
    mounted() {
        this.init()
        this.$nextTick(() => {
            this.initAlarmTrend();
            window.addEventListener("resize", () => {
                this.$echarts.init(document.getElementById("chart")).resize();
            });
        })
    },

    methods: {
        init() {

        },
        async adjust(){
            this.isComputing = true
            var item = {
                num: ''
            }
            if (this.value1[1]=='01'){
                item.num =4
                if (this.input1>1000){
                    item.height_max =462
                }else if(this.input1>500){
                    item.height_max =460
                }else {
                    item.height_max =459
                }
            }else if (this.value1[1]=='02'){
                item.num =4
                if (this.flowList[0].out>1000){
                    item.height_max =462
                }else if (this.flowList[0].out>500){
                    item.height_max =460
                }else {
                    item.height_max =459
                }
            }else if (this.value1[0]=='2'){
                item.num =4
                if (this.input2>2000){
                    item.height_max =462
                }else {
                    item.height_max =460
                }
            }

            const payload = this._buildDispatchPayload(item)
            this.lastDispatchPayload = payload
            try {
                this.dispatchResult = await compareDispatch(payload)
                this.workflowScheme = null
                this.workflowCommand = null
                this.workflowAudit = []
                this.workflowMessage = '方案比选完成，可创建执行方案。'
                const recommended = this.dispatchResult.schemes.find(s => s.scheme_id === this.dispatchResult.recommended_scheme_id) || this.dispatchResult.schemes[0]
                this.floodScenario = await runFloodScenario({
                    ...payload,
                    dispatch_result: recommended,
                    scenario_name: '龙门断面洪水演进'
                })
                item.dispatchResult = this.dispatchResult
                item.floodScenario = this.floodScenario
                item.height_max = this.floodScenario.metrics.max_stage
                item.num = item.num || 4
                this.$message.success(this.dispatchResult.summary)
            } catch (error) {
                console.error('[custom] dispatch compute failed:', error)
                this.$message.error('调度方案计算失败，已使用默认预演参数。')
            } finally {
                this.isComputing = false
            }
            this.$emit('adjust',item,null)
        },
        async createWorkflowScheme() {
            if (!this.dispatchResult) {
                this.$message.warning('请先完成调度方案比选')
                return
            }
            await this._runWorkflowAction(async () => {
                this.workflowScheme = await createDispatchScheme({
                    source: 'custom-panel',
                    created_by: 'operator-a',
                    dispatch_payload: this.lastDispatchPayload || {},
                    dispatch_result: this.dispatchResult,
                    recommended_scheme_id: this.dispatchResult.recommended_scheme_id
                })
                this.workflowMessage = `已创建执行方案 ${this.workflowScheme.scheme_id}`
            })
        },
        async submitWorkflowScheme() {
            await this._runWorkflowAction(async () => {
                this.workflowScheme = await submitDispatchScheme(this.workflowScheme.scheme_id, {
                    role: 'operator',
                    user: 'operator-a'
                })
                this.workflowMessage = '方案已提交审批。'
            })
        },
        async approveWorkflowScheme() {
            await this._runWorkflowAction(async () => {
                this.workflowScheme = await approveDispatchScheme(this.workflowScheme.scheme_id, {
                    role: 'approver',
                    user: 'chief-dispatcher',
                    confirm_token: 'CONFIRM',
                    comment: '同意按推荐方案下发'
                })
                this.workflowMessage = '审批已完成，二次确认令牌已校验。'
            })
        },
        async issueWorkflowCommand() {
            await this._runWorkflowAction(async () => {
                this.workflowCommand = await issueDispatchCommand({
                    scheme_id: this.workflowScheme.scheme_id,
                    role: 'operator',
                    user: 'operator-a',
                    confirm_token: 'CONFIRM',
                    target: 'guxian-reservoir-dispatch-center'
                })
                this.workflowScheme = {
                    ...this.workflowScheme,
                    execution_status: 'issued',
                    commands: [...(this.workflowScheme.commands || []), this.workflowCommand.command_id]
                }
                this.workflowMessage = `指令已下发：${this.workflowCommand.command_id}`
            })
        },
        async completeWorkflowReceipt() {
            await this._runWorkflowAction(async () => {
                const telemetry = this.workflowCommand?.payload || {}
                this.workflowCommand = await recordDispatchReceipt(this.workflowCommand.command_id, {
                    status: 'completed',
                    reported_by: 'field-device-01',
                    message: '现场闸门调节完成，遥测回执正常',
                    telemetry: {
                        release_m3s: Number(telemetry.target_release_m3s || this.input1 || 980),
                        level_m: Number(telemetry.max_level_m || this.input2 || 616.2)
                    }
                })
                this.workflowScheme = {
                    ...this.workflowScheme,
                    execution_status: 'completed'
                }
                this.workflowMessage = '执行回执已记录，闭环完成。'
            })
        },
        async failWorkflowReceipt() {
            await this._runWorkflowAction(async () => {
                this.workflowCommand = await recordDispatchReceipt(this.workflowCommand.command_id, {
                    status: 'failed',
                    reported_by: 'field-device-01',
                    message: '现场执行失败，等待重试下发',
                    telemetry: {}
                })
                this.workflowScheme = {
                    ...this.workflowScheme,
                    execution_status: 'failed'
                }
                this.workflowMessage = '失败回执已记录，可执行重试下发。'
            })
        },
        async retryWorkflowCommand() {
            await this._runWorkflowAction(async () => {
                this.workflowCommand = await retryDispatchCommand(this.workflowCommand.command_id, {
                    role: 'operator',
                    user: 'operator-a',
                    confirm_token: 'CONFIRM',
                    target: 'guxian-reservoir-dispatch-center'
                })
                this.workflowScheme = {
                    ...this.workflowScheme,
                    execution_status: 'retry_issued',
                    commands: [...(this.workflowScheme.commands || []), this.workflowCommand.command_id]
                }
                this.workflowMessage = `重试指令已下发：${this.workflowCommand.command_id}`
            })
        },
        async cancelWorkflowScheme() {
            await this._runWorkflowAction(async () => {
                this.workflowScheme = await cancelDispatchScheme(this.workflowScheme.scheme_id, {
                    role: 'operator',
                    user: 'operator-a',
                    confirm_token: 'CONFIRM',
                    reason: 'frontend operator rollback'
                })
                if (this.workflowCommand && this.workflowCommand.status === 'issued') {
                    this.workflowCommand = { ...this.workflowCommand, status: 'cancelled' }
                }
                this.workflowMessage = '方案执行已撤销。'
            })
        },
        async loadWorkflowAudit() {
            await this._runWorkflowAction(async () => {
                const result = await fetchDispatchAudit()
                this.workflowAudit = result.audit || []
                this.workflowMessage = `已读取 ${result.count || this.workflowAudit.length} 条审计记录。`
            })
        },
        async _runWorkflowAction(action) {
            this.workflowLoading = true
            try {
                await action()
            } catch (error) {
                console.error('[custom] dispatch workflow failed:', error)
                this.workflowMessage = `执行失败：${error.message}`
                this.$message.error(this.workflowMessage)
            } finally {
                this.workflowLoading = false
            }
        },
        _buildDispatchPayload(item) {
            const fixedRelease = Number(this.input1 || this.flowList[0]?.out || 980)
            const initialLevel = Number(this.input2 || 616.2)
            return {
                mode: this.value1[1] === '01' ? 'fixed' : this.value1[1] === '02' ? 'pre_release' : 'compensation',
                fixed_release: fixedRelease,
                initial_level: initialLevel,
                target_level: 617.4,
                horizon_hours: 24,
                safe_release: 1800,
                source: 'custom-panel',
                height_hint: item.height_max
            }
        },
        riverLevel(){
            var level = []
            if (this.value1[1]=='01'){
                level = [2050,2030]
            }else if (this.value1[1]=='02'){
                level = [2050,2030]
            }else if (this.value1[0]=='2'){
                level = [this.input2   ,2000]

            }
            this.$emit('initLevel',level)
        },
        initAlarmTrend() {
            // 基于准备好的dom，初始化echarts实例


            let myChart = this.$echarts.init(document.getElementById("chart"));
            // 绘制图表
            myChart.setOption({
                grid:{
                    x2:80,
                },
                xAxis: {
                    type: 'category',
                    data: ['1', '2', '3', '4', '5', '6', '7'],
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 2300,
                    max: 1700,
                    axisLine: {
                        show: true,
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel:{
                        textStyle: {
                            color: '#c3dbff',  //更改坐标轴文字颜色
                            fontSize : 14      //更改坐标轴文字大小
                        },
                    },
                },
                series: [
                    {
                        data: [2280, 1940, 1830, 1790, 1770, 1750, 1740],
                        type: 'line',
                        smooth: true,
                        itemStyle:{
                            normal:{
                                lineStyle: {
                                    color:'#01fef9'
                                }
                            }
                        },

                        markLine: {
                            silent: true,
                            lineStyle: {
                                normal: {
                                    color: '#01fef9'                   // 这儿设置安全基线颜色
                                }
                            },
                            data: [
                                {
                                    label: {
                                        normal: {
                                            formatter: '校核水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 2180,
                                },{
                                    label: {
                                        normal: {
                                            formatter: '设计水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 2130,
                                },
                                {
                                    label: {
                                        normal: {
                                            formatter: '防洪高水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 2080,
                                },
                                {
                                    label: {
                                        normal: {
                                            formatter: '兴利水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 2030,
                                },
                                {
                                    label: {
                                        normal: {
                                            formatter: '防洪限制水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 2000,
                                },
                                {
                                    label: {
                                        normal: {
                                            formatter: '死水位'           // 这儿设置安全基线
                                        }
                                    },
                                    yAxis: 1900,
                                },

                            ],

                        },

                    }
                ]
            });


        },
        selectItem(item) {
            if (item.num == 3 && !item.select) {
                this.showFlag = true
            } else {
                this.showFlag = false
            }
            // if(item.num!=3){
            //   this.showFlag=false
            // }

        },
        deleteItem(item, index) {
            this.flowList.splice(index, 1)
        },
        startFlow() {
            this.$emit('nextChange')
        },
        regulate(item) {
            item.select = !item.select
            this.$emit('adjust', item,null)
        },
        defend(item) {
            item.select = !item.select
            this.$emit('conservation', item)
        },
        customization() {

        },
        addItem() {
            this.flowList.push({
                in: '',
                out: ''
            })
        },
        handleChange(value) {
            console.log(this.value1)
        }
        // myFunction(event){
        //   event.preventDefault();//阻止默认事件
        //   this.$emit('nextChange')
        // }
    }
}
</script>

<style scoped>
.backGround {
    position: relative;
    background: url(../assets/twoR.png) no-repeat center center;
    background-size: 100% 100%
}

/deep/ .el-dialog,
.el-pager li {
    background-color: rgba(30, 144, 255, 0.0);
    background-image: url(../assets/twoR.png);
    background-size: 100% 100%;
}

::v-deep .el-input__inner {
    border: 1px solid #76d9ff;
    background-color: transparent !important;
}

.blue-button {
    background-color: #76d9ff;
}

.button1 {
    height: 30px;
    width: 80px;
    background-image: linear-gradient(to right bottom, #76d9ff, rgba(56, 189, 248, 0.38), #76d9ff);
    opacity: 0.9;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    float: right;
    text-align: center;
    margin: 20px 30px 0 0;
}
/deep/.el-input__inner {
    border: 1px solid #76d9ff;
    color: white;
}

.dispatch-result {
    position: absolute;
    right: 24%;
    top: 90px;
    width: 24%;
    max-height: calc(100vh - 126px);
    padding: 12px;
    color: #dffcff;
    overflow: hidden;
}

.dispatch-summary {
    margin: 8px 10px 10px;
    padding: 8px 10px;
    border: 1px solid rgba(56, 189, 248, 0.25);
    border-radius: 6px;
    background: rgba(56, 189, 248, 0.08);
    font-size: 13px;
    line-height: 1.5;
}

.scheme-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 10px 10px;
}

.scheme-card {
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 8px;
    padding: 9px;
    background: rgba(0, 20, 28, 0.62);
}

.scheme-card.recommended {
    border-color: rgba(56, 189, 248, 0.65);
    box-shadow: 0 0 10px rgba(56, 189, 248, 0.18);
}

.scheme-name {
    color: #76d9ff;
    font-weight: 700;
    margin-bottom: 6px;
}

.scheme-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px 8px;
    font-size: 12px;
    color: rgba(223, 252, 255, 0.86);
}

.scheme-tip {
    margin-top: 6px;
    color: rgba(223, 252, 255, 0.72);
    font-size: 12px;
    line-height: 1.45;
}

.workflow-panel {
    margin: 0 10px 10px;
    padding: 10px;
    border: 1px solid rgba(56, 189, 248, 0.28);
    border-radius: 8px;
    background: rgba(0, 28, 38, 0.68);
}

.workflow-title {
    color: #76d9ff;
    font-weight: 700;
    margin-bottom: 8px;
}

.workflow-status {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5px 8px;
    color: rgba(223, 252, 255, 0.86);
    font-size: 12px;
    line-height: 1.4;
}

.workflow-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 9px;
}

.workflow-message {
    margin-top: 8px;
    color: #b9fbff;
    font-size: 12px;
    line-height: 1.45;
}

.workflow-audit {
    margin-top: 8px;
    max-height: 96px;
    overflow-y: auto;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    padding-top: 6px;
}

.audit-line {
    color: rgba(223, 252, 255, 0.72);
    font-size: 11px;
    line-height: 1.5;
}


</style>
